module.exports = __webpack_public_path__ + "static/img/0002.f6fe120.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/guide/ustd/0002.png
// module id = zOHV
// module chunks = 1